import { ComponentPropsWithoutRef, CSSProperties, FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

import { Body } from '@rikstv/shared-components';

import styles from './ClampLines.module.css';

/** Standard HTML attributes plus the design system's own typography props (`lookLike`, `lightBackground`, `as`). */
type TypographyProps = HTMLAttributes<HTMLElement> &
  Omit<ComponentPropsWithoutRef<typeof Body>, keyof HTMLAttributes<HTMLParagraphElement>>;

/** Accepts everything `TextStyle` does, so callers can pass `lookLike`, `aria-hidden`, `id`, `role` and the like. */
type Props = Omit<TypographyProps, 'children'> & {
  textStyle: FC<TypographyProps>;
  lines?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  children: string;
};
export const ClampLines: FC<Props> = ({ children, textStyle: TextStyle, lines = 2, className, style, ...rest }) => {
  return (
    <TextStyle
      {...rest}
      style={{ ...style, ['--clamp-lines-length-var']: lines.toString() } as CSSProperties}
      className={classNames(`${className} ${styles.clampClass}`)}
      title={children}>
      {children}
    </TextStyle>
  );
};
